import "./AboutusStyles.css"
import IMG_00 from '../Assets/CEO.jpg';
function AboutUs() {
    return(
<>

<div className="fd"> 
    <h2> Founder and CEO </h2>
    <center>
        <div className="fimage">
            <img alt="img" src={IMG_00}/></div>
            <br></br>
            <b><p>Dr. Margaret Njoroge </p></b>
            
    </center>
    </div>
<div className="about-container">
           <div className="f-content">
                    
                    
                    <div className="founder">
                    
                        <p>
                            Elevate Life and Mental Wellness Hub is committed to enhancing the 
                            emotional, psychological, and relational well-being of individuals,
                             families, organizations, and communities. We offer holistic mental 
                             health services including counseling, training, research, 
                             consultancy, and community education designed to help people 
                             navigate life’s challenges with confidence, resilience, and hope.
                            Our work extends beyond individual care. We engage in mental health 
                            research, provide consultancy services to institutions such as
                             schools, churches, companies, and community organizations, and 
                             lead public education initiatives to raise awareness and promote 
                             mental wellness across different sectors of society.
                            We believe that mental wellness is essential for thriving families
                             and strong communities. Through accessible, culturally informed, 
                             and compassionate care, we strive to create environments where 
                             every person feels valued, supported, and empowered to elevate 
                             their life and well-being.

                        </p>
                    </div>
           </div>
           


            <br></br>
            <br></br>
            <h1>
                Our History
            </h1>
            <p>
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
        Curabitur euismod turpis ac quam interdum, sit amet maximus ligula elementum.
        Praesent lectus risus, iaculis sit amet nunc quis, pretium aliquam leo. Morbi efficitur
        commodo justo a finibus. Donec lorem lectus, ullamcorper eget commodo sit amet, sodales
        non neque. Vivamus sapien massa, scelerisque id sodales sit amet, rutrum in ex.
        Curabitur tellus tellus, placerat vitae gravida scelerisque, elementum at metus. 
        Curabitur a lobortis lectus,
            </p>

            <h1>
                Our Vision
            </h1>
            <p>
            To create an environment where families, churches, religious organizations, companies and communities thrive through accessible mental health services, strong relationships, and resilience in facing life’s challenges.
            </p>

            <h1>
                Our Mission
            </h1>
            <p>
           To empower individuals and families to thrive through holistic training programs, counseling services, and mental health support, fostering resilience, harmony, and overall well-being.
            </p>
        </div>

</>
        
    )
    
}

export default AboutUs;